/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Role_AnsweredInputs */

const en_endpoint_role_answered = /** @type {(inputs: Endpoint_Role_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answered`)
};

const zh_hans1_endpoint_role_answered = /** @type {(inputs: Endpoint_Role_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已返回`)
};

const pt_br2_endpoint_role_answered = /** @type {(inputs: Endpoint_Role_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respondeu`)
};

const es_endpoint_role_answered = /** @type {(inputs: Endpoint_Role_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respondió`)
};

const fr_endpoint_role_answered = /** @type {(inputs: Endpoint_Role_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A répondu`)
};

const de_endpoint_role_answered = /** @type {(inputs: Endpoint_Role_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantwortet`)
};

const ru_endpoint_role_answered = /** @type {(inputs: Endpoint_Role_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ответил`)
};

const it_endpoint_role_answered = /** @type {(inputs: Endpoint_Role_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ha risposto`)
};

/**
* | output |
* | --- |
* | "Answered" |
*
* @param {Endpoint_Role_AnsweredInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_role_answered = /** @type {((inputs?: Endpoint_Role_AnsweredInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Role_AnsweredInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_role_answered(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_role_answered(inputs)
	if (locale === "es") return es_endpoint_role_answered(inputs)
	if (locale === "fr") return fr_endpoint_role_answered(inputs)
	if (locale === "de") return de_endpoint_role_answered(inputs)
	if (locale === "ru") return ru_endpoint_role_answered(inputs)
	if (locale === "it") return it_endpoint_role_answered(inputs)
	return en_endpoint_role_answered(inputs)
});